<template>
    <div>
        <input v-model = "titleField"
        :type="tipo || 'text'" :class=" clase || ''"
        @input = "editTodo">
    </div>
</template>
<script>
import Axios from 'axios';
export default {
    props: [
        'value',
        'url',
        'method',
        'field',
        'clase',
        'tipo'
    ],
    data () {
        return {
            titleField: this.value,
        }
    },
    methods: {
        editTodo: function(evt) {
            const vm = this
            setTimeout(()=>{
                Axios( {
                    method: vm.method,
                    url: vm.url,
                    data: {
                        [vm.field]: vm.titleField,
                    }
                })
            },
            100)
        },
    },
    watch:{
        value (val) {
            this.titleField = val
        }
    }
}
</script>
